<template>
  <div>
    <div class="container-fluid mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Listado de Créditos">
            <div class="vx-row">
              <div class="vx-col sm:w-full">
                <div class="flex flex-grow">
                  <vs-select placeholder="Seleccione" label="Filtros" v-model="creditsFilterOptionSelected">
                    <vs-select-item :key="index" :value="item.value" :text="item.text"
                      v-for="(item, index) in creditsFilterOptions" />
                  </vs-select>
                  <vs-button @click="getData" :disabled="!creditsFilterOptionSelected" color="dark" class="mt-6 ml-3">Filtrar</vs-button>
                  <vs-button :disabled="selectedProjectsIdsToAssign.length == 0" @click="popupAssignActive = true" color="success"
                    class="mt-6 ml-3">Adjudicar</vs-button>
                  <vs-button :disabled="selectedProjectsIdsToUnassign.length == 0" @click="confirmUnassignDebtCollector" color="danger"
                    class="mt-6 ml-3">Quitar</vs-button>
                </div>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-table pagination ref="projectsTable" stripe class="mt-5" :max-items="80" :data="projects"
                  noDataText="No hay datos disponibles">
                  <template slot="thead">
                    <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                      :sort-key="col.sortable ? col.key : null">{{ col.title }}
                    </vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td></vs-td>
                      <vs-td>
                        <vs-button v-if="selectedProjectsIdsToAssign.length == projectsAvailableToAssign.length"
                            @click="selectUnselectAllToAssign('unselect')" color="dark"
                            size="small">Deseleccionar</vs-button>
                          <vs-button v-else @click="selectUnselectAllToAssign('select')" color="dark"
                            size="small">Seleccionar</vs-button>
                      </vs-td>
                      <vs-td>
                        <vs-button v-if="selectedProjectsIdsToUnassign.length == projectsAvailableToUnassign.length"
                            @click="selectUnselectAllToUnassign('unselect')" color="dark"
                            size="small">Deseleccionar</vs-button>
                          <vs-button v-else @click="selectUnselectAllToUnassign('select')" color="dark"
                            size="small">Seleccionar</vs-button>
                      </vs-td>
                    </vs-tr>
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                      <vs-td>                       
                        <a :href="$sanitizeUrl('/cobranza/' + tr.project_id)" class="bold text-dark pill-light" target="_blank">{{ tr.project_id }}</a>
                      </vs-td>
                      <vs-td>{{ tr.alias }}</vs-td>
                      <vs-td>{{ tr.applicant_name }}</vs-td>
                      <vs-td>{{ explicitCreditStatus(tr.credit_status) }}</vs-td>
                      <vs-td v-if="tr.promise_payment">
                        <label>{{ midDateFormat(tr.promise_payment.promise_date) }}</label><br>
                        <label>Monto: <b>{{ costFormat(tr.promise_payment.amount_promised) }}</b></label>
                      </vs-td>
                      <vs-td v-else></vs-td>
                      <vs-td>{{ tr.debt_collector_current_month }}</vs-td>
                      <vs-td>{{ tr.debt_collector_next_month }}</vs-td>
                      <vs-td>
                        <vs-checkbox :disabled="tr.debt_collector_next_month != null"
                          v-model="selectedProjectsIdsToAssign" :vs-value="tr.project_id" color="success"></vs-checkbox>
                      </vs-td>
                      <vs-td>
                        <vs-checkbox :disabled="tr.debt_collector_next_month == null"
                          v-model="selectedProjectsIdsToUnassign" :vs-value="tr.project_id"
                          color="danger"></vs-checkbox>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <!-- MODAL ADJUDICAR -->
    <vs-popup class="mid-popup header-primary" title="Adjudicar" :active.sync="popupAssignActive">
      <div class="vx-row mt-base mb-base">
        <div class="vx-col w-full">
          <vs-select placeholder="Seleccione" label="Despacho" class="w-full" v-model="debtCollectorSelected">
            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in debtCollectors" />
          </vs-select>
          <vs-select placeholder="Seleccione" label="Mes de asignación" class="w-full mt-5" v-model="monthSelected">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in monthOptions" />
          </vs-select>
          <vs-button :disabled="!debtCollectorSelected || !monthSelected" @click="confirmAssignDebtCollector" color="success" class="mt-6 mb-6 mr-1">Continuar</vs-button>
        </div>
      </div>
    </vs-popup>
    <!--  -->
  </div>

</template>

<script lang="js">
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import creditStatusesHelper from "@mixins/creditStatusesHelper";

import { formatPrice, formatMoney } from '../../../components/admin/filters.js';
import Toasted from 'vue-toasted';
import * as moment from 'moment'
import { BankAccountStatus } from "@/models/BankAccountStatus";

const columnDefinitions = [
  { title: "PID", key: "project_id", sortable: false },
  { title: "ALIAS", key: "alias", sortable: false },
  { title: "SOLICITANTE", key: "applicant", sortable: false },
  { title: "ESTATUS", key: "status", sortable: false },
  { title: "PROMESA DE PAGO", key: "promise", sortable: false },
  { title: "DESPACHO MES ACTUAL", key: "current_debt", sortable: false },
  { title: "DESPACHO MES SIGUIENTE", key: "next_debt", sortable: false },
  { title: "ADJUDICAR", key: "assign", sortable: false },
  { title: "QUITAR", key: "unassign", sortable: false }
];
export default {
  props: [],
  mixins: [dateHelper, creditStatusesHelper, formatHelper],
  async mounted() {
    // await this.getData();
  },
  data() {
    return {
      creditsFilterOptionSelected: null,
      creditsFilterOptions: [
        { text: 'B1', value: 'b1' },
        { text: 'B2', value: 'b2' },
        { text: 'B3', value: 'b3' },
        { text: 'B4', value: 'b4' }
      ],
      columns: columnDefinitions,
      projects: [],
      selectedProjectsIdsToAssign: [],
      selectedProjectsIdsToUnassign: [],
      popupAssignActive: false,
      debtCollectorSelected: null,
      debtCollectors: [],
      monthSelected: null,
      monthOptions: [
        { text: 'Actual', value: 'current' },
        { text: 'Siguiente', value: 'next' }
      ],
    }
  },
  computed: {
    projectsAvailableToAssign() {
      return this.projects.filter(function (project) {
        return project.debt_collector_next_month == null
      })
    },
    projectsAvailableToUnassign() {
      return this.projects.filter(function (project) {
        return project.debt_collector_next_month != null
      })
    }
  },
  methods: {
    formatPrice,
    async getData() {
      this.showLoading(true);
      this.projects = [];
      this.debtCollectors = [];
      await axios.post('/api/cobranza/projects-to-assign-debt-collector', {
        filter_selected: this.creditsFilterOptionSelected,
      }).then(response => {
        this.projects = response.data.projects;
        this.debtCollectors = response.data.debt_collectors;
        this.showLoading(false);
      }).catch(error => {
        this.showLoading(false);
      });
    },
    selectUnselectAllToAssign(option) {
      this.selectedProjectsIdsToAssign = [];
      if (option == "select") {
        this.projectsAvailableToAssign.forEach((credit) => this.selectedProjectsIdsToAssign.push(credit.project_id));
      }
    },
    selectUnselectAllToUnassign(option) {
      this.selectedProjectsIdsToUnassign = [];
      if (option == "select") {
        this.projectsAvailableToUnassign.forEach((credit) => this.selectedProjectsIdsToUnassign.push(credit.project_id));
      }
    },
    confirmAssignDebtCollector(){
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Aviso`,
          text: "¿Estas seguro de querer adjudicar el despacho a los proyectos seleccionados ("+ this.selectedProjectsIdsToAssign.length +")?",
          acceptText: "Confirmar",
          cancelText: "Cancelar",
          accept: this.assignDebtCollector
      })
    },
    confirmUnassignDebtCollector(){
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Aviso`,
          text: "¿Estas seguro de querer quitar el despacho a los proyectos seleccionados ("+ this.selectedProjectsIdsToUnassign.length +")?",
          acceptText: "Confirmar",
          cancelText: "Cancelar",
          accept: this.unassignDebtCollector
      })
    },
    async assignDebtCollector() {
      this.showLoading(true);
      let payload = {
        projects_ids: this.selectedProjectsIdsToAssign,
        debt_collector_id: this.debtCollectorSelected,
        option_month: this.monthSelected,
      };
      await axios.post('/api/cobranza/assign-debt-collector-projects', payload).then(response => {
        this.resetValues();
        this.showLoading(false);
        this.getData();
        this.successNotif("Aviso", 'Despacho asignado exitosamente', 4000);
      }).catch(error => {
        this.showLoading(false);
        if (error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
        }
      });
    },
    async unassignDebtCollector() {
      this.showLoading(true);
      let payload = {
        projects_ids: this.selectedProjectsIdsToUnassign,
      };
      await axios.post('/api/cobranza/unassign-debt-collector-projects', payload).then(response => {
        this.resetValues();
        this.showLoading(false);
        this.getData();
        this.successNotif("Aviso", 'Despacho quitado exitosamente', 4000);
      }).catch(error => {
        this.showLoading(false);
        if (error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
        }
      });
    },
    async resetValues() {
      this.selectedProjectsIdsToAssign = [];
      this.selectedProjectsIdsToUnassign = [];
      this.popupAssignActive=false;
      this.monthSelected = null;
      this.debtCollectorSelected = null;
    }
  }
}
</script>

<style>
.con-vs-dialog {
  z-index: 100000 !important;
}
</style>